/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {addThousandSeparator} from '../../../common/utils/functions';
import {SelectTypeProps} from '../../../data/types/interface/Assurance/AssuranceVoyage';
import {styles} from './styles';

export const SelectType = ({
  listTypes,
  selected = '',
  onSelect,
  name = '',
  messages = [],
}: SelectTypeProps) => {
  const isDisabled = () => listTypes.length > 1;
  return (
    <View>
      {listTypes.length
        ? listTypes.map((element: any, index: number) => {
            const montant = `${addThousandSeparator(
              typeof element.montant === 'number'
                ? element.montant
                : parseInt(element.montant),
            )} Ar`;

            return (
              <TouchableOpacity
                key={`list_montant_${index}`}
                style={styles.resultContainer}
                disabled={!isDisabled()}
                onPress={() => onSelect(name || '', element.destination)}>
                {isDisabled() && selected ? (
                  <View
                    style={[
                      styles.disabledSelected,
                      {
                        backgroundColor:
                          selected === element.destination ? 'green' : 'white',
                      },
                    ]}
                  />
                ) : null}
                <View style={{flex: 1}}>
                  <Text
                    style={
                      styles.resultDestination
                    }>{`${element.destination?.replace(
                    /\([^)]*\)/g,
                    '',
                  )}`}</Text>
                  <Text style={styles.resultMontant}>{montant}</Text>
                  {messages.length > 0 ? (
                    <Text style={styles.message}>{`(${messages[index]})`}</Text>
                  ) : null}
                </View>
              </TouchableOpacity>
            );
          })
        : null}
    </View>
  );
};
